import { render } from "./audit-log-settings.vue?vue&type=template&id=6dc7cf00&ts=true"
import script from "./audit-log-settings.vue?vue&type=script&lang=ts"
export * from "./audit-log-settings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__